export default __webpack_public_path__ + "5bb3c7908498a0ed237825a1e6e57c8a.svg";